export default __webpack_public_path__ + "static/media/logo.3a6105c1.jpg";